import { validator } from "LIB/validate-this";
import * as rules from "LIB/validation/rules";
import { validateLineItem } from "MODULES/OutgoingQuotes/shared/Parts/validate";
import _ from "lodash";
import { AUTO_FOLLOWUP_DAYS } from "MODULES/OutgoingQuotes/constants";

export default function validate(values, props) {
  return validator(values, form => {
    if (!_.isEmpty(values.contact)) {
      form.validateChild("contact", contactForm => {
        contactForm.validate("name", "email").satisfies(rules.required);
        contactForm.validate("email").satisfies(rules.isValidEmail);
      });
    } else {
      form.validate("contact_id").satisfies(rules.required);
    }

    if (!_.isEmpty(values.company)) {
      form.validateChild("company", company => {
        company.validate("name").satisfies(rules.required);
      });
    } else {
      form.validate("company_id").satisfies(rules.required);
    }

    if (values.auto_followup) {
      form.validate(AUTO_FOLLOWUP_DAYS).satisfies(rules.required);
      form
        .validate(AUTO_FOLLOWUP_DAYS)
        .satisfies(
          rules.isGreaterThanOrEqualTo(1),
          rules.isLessThanOrEqualTo(14)
        );
    }

    if (props.selectedCompany) {
      form
        .validate("company_id")
        .satisfies(() => rules.validateCompanyStatus(props.selectedCompany));
    }

    form.validateChild("outgoing_quote_line_item", lineItem => {
      validateLineItem(lineItem, values, "outgoing_quote_line_item");
    });
  });
}



// WEBPACK FOOTER //
// ./app/modules/parts/components/Detail/OutgoingQuotes/validate.js